import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Card,
  Form,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Collapse,
  Select,
  InputNumber,
  Button,
  Modal,
  Tooltip,
  List,
} from "antd";
import {
  DeleteOutlined,
  PlusCircleOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../systemAdmin.config";
import { accountStatus } from "../../../components/facilities/AccountFacility";
import styles from "../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { TextArea } = Input;
const { Content } = Layout;
const { Panel } = Collapse;

const EditVaultConfiguration = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { Text, Title } = Typography;
  const isLienAllowed = Form.useWatch("lienAllowed", form);
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  // CHARGES FORM REQURED VARIABLES
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [officeData, setOfficeData] = useState([]);
  const [templateConfigDetail, setTemplateConfigDetail] = useState({});
  const [currencyData, setCurrencyData] = useState([]);
  const [currencyCount, setCurrencyCount] = useState(0);
  const [glAccountData, setGLAccountData] = useState([]);
  const [configureCurrencyTableSource, setConfigureCurrencyTableSource] =
    useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    configForm: {
      operationId: null,
      vaultGl: null,
      tillGl: null,
    },
    currencyForm: [],
  });

  const [codeList, setCodeList] = useState([]);
  const [
    selectedbranchConfigValueCurrencyCode,
    setSelectedbranchConfigValueCurrencyCode,
  ] = useState(0);
  const [selectedbranchConfigValue, setSelectedbranchConfigValue] = useState(0);
  const [branchConfigList, setBranchConfigList] = useState([]);
  const [fetchedData, setFetchedData] = useState(null); // for objList
  const [isBranchListLoaded, setIsBranchListLoaded] = useState(false);
  const [isVaultDataLoaded, setIsVaultDataLoaded] = useState(false);
  const [isGlAccountLoaded, setIsGlAccountLoaded] = useState(false);
  const [isSetbranchCurrencyrestrById, setIsSetBranchCurrencyrestrById] =
    useState(false);

  useEffect(() => {
    // getOffices();
    getCurrencies();
    getGLAccounts();
    getBranchConfigList();
    getBranchValutById();
  }, []);
  // console.log(isSetbranchCurrencyrestrById)
  useEffect(() => {
    if (
      isGlAccountLoaded &&
      isBranchListLoaded &&
      isVaultDataLoaded &&
      fetchedData
    ) {
      setSelectedbranchConfigValue(fetchedData.operationId2?.id);
      const selected = branchConfigList.find(
        (item) => item.value === fetchedData.operationId2?.id,
      );

      const selectedValultGl = glAccountData.find(
        (item) => item.value === fetchedData?.vaultGl?.id,
      );

      const selectedTillGl = glAccountData.find(
        (item) => item.value === fetchedData.tillGl?.id,
      );
      form.setFieldsValue({
        operationId: selected?.value,
        vaultGl: selectedValultGl?.value,
        tillGl: selectedTillGl?.value,
      });
    }
  }, [isBranchListLoaded, isVaultDataLoaded, fetchedData, isGlAccountLoaded]);

  useEffect(() => {
    if (selectedbranchConfigValue > 0) {
      getBranchCurrencyrestrById();
    }
  }, [selectedbranchConfigValue]);

  // Assuming you have form instance: const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(formData.configForm);
  }, [formData.configForm]);

  const getBranchCurrencyrestrById = () => {
    let body = { session };
    // selectedbranchConfigValue
    let url = `${
      apiConfig.Branchoprconfig +
      `/branchcurrencyrestr` +
      `/${selectedbranchConfigValue}`
    }`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        console.log(res);

        const currencyOptions = res.map((item) => ({
          value: item.currencyCode,
          label: item.currencyCode,
        }));

        setSelectedbranchConfigValueCurrencyCode(currencyOptions);
        setIsSetBranchCurrencyrestrById(true);
      }
    });
  };

  const getBranchValutById = () => {
    const url = `${apiConfig.VaultConfig + "/" + state.id}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        setCodeList(objList);
        console.log(res);
        setFormData({
          configForm: {
            operationId: objList?.operationId2?.id || null,
            vaultGl: objList?.vaultGl?.id || null,
            tillGl: objList?.tillGl?.id || null,
          },
          currencyForm: objList?.vaultCcyRestrConfData || [],
        });

        setFetchedData(res);
        setIsVaultDataLoaded(true);
        setConfigureCurrencyTableSource(objList.vaultCcyRestrConfData);
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getBranchConfigList = () => {
    let body = { session };

    BOM.FetchReqAction(body, apiConfig.Branchoprconfig, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        console.log(res);
        const dropdownOptions = res.map((element) => ({
          value: element.id,
          label: element.officeId.name,
        }));

        setBranchConfigList(dropdownOptions);
        setIsBranchListLoaded(true);
        setIsLoading(false);
      }
    });
  };
  const getCurrencies = () => {
    setIsLoading(true);

    const url = apiConfig.Currencies;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetails = res;
        let tempCurrencyData = [];

        objDetails?.selectedCurrencyOptions?.forEach((element) => {
          tempCurrencyData.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(tempCurrencyData);

        setIsLoading(false);
      }
    });
  };

  const getGLAccounts = () => {
    setIsLoading(true);

    const url = apiConfig.GLAccounts;

    let body = {
      session,
      params: { offset: 0, orderBy: "id", sortOrder: "DESC" },
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetails = res.pageItems;
        let tempGLAccountData = [];

        objDetails?.forEach((element) => {
          tempGLAccountData.push({
            value: element.id,
            label: element.name,
          });
        });
        setGLAccountData(tempGLAccountData);
        setIsGlAccountLoaded(true);

        setIsLoading(false);
      }
    });
  };

  const handleVaultCurrencyDelete = (record) => {
    const id = record.id; // Extract id from the entire record
    console.log(id);

    Notiflix.Confirm.show(
      "Please confirm action",
      "",
      "Yes",
      "No",
      function () {
        // Filter out the deleted item from local state
        const newData = configureCurrencyTableSource.filter(
          (item) => item.id !== id,
        );

        setConfigureCurrencyTableSource(newData);

        // Also remove from formData.currencyForm to keep in sync
        setFormData((prev) => ({
          ...prev,
          currencyForm: prev.currencyForm.filter((item) => item.id !== id),
        }));

        // Update Ant Design form fields to reflect deletion
        form.setFieldsValue({
          currencyForm: [...newData], // spread to create new array
        });
      },
      function () {
        // Cancel clicked - do nothing
      },
    );
  };

  const columns = [
    {
      title: "Vault Currency",
      dataIndex: "currencyCode",
    },
    {
      title: "Maximum Vault Limit",
      dataIndex: "vaultMaxAmount",
      render: (value) => (value != null ? Number(value).toLocaleString() : "-"),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        configureCurrencyTableSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleVaultCurrencyDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const onSubmit = (formValues) => {
    const url = `${apiConfig.VaultConfig + "/" + state.id}`;
    const payload = {
      locale: "en", // fixed as 'en' here, but you can change if dynamic needed
      operationId: formData?.configForm?.operationId,
      vaultGl: formData?.configForm?.vaultGl,
      tillGl: formData?.configForm?.tillGl,
      id: state.id,
      vaultCcyRestrConfs:
        formData?.currencyForm?.map((item) => ({
          vaultCcyRestrConf: {
            locale: "en",
            id: item.id,
            currencyCode: item.currencyCode,
            vaultMaxAmount: item.vaultMaxAmount.toString(),
          },
        })) || [], // fallback empty array if no currencyForm
    };
    const body = {
      locale: "en",
      ...payload,
      method: "PUT",
      session,
    };

    console.log(formData);

    console.log(body);
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Branch vault updated successfully");
          // navigate("/detail-savings-account", {
          //   state: { ...state, statusValue: accountStatus.submittedAndPending },
          // });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/sya0500");
          setIsLoading(false);
        },
      },
    );
  };

  function onCancel() {
    navigate("/sya0500", { state: state });
  }
  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.editVaultConfiguration}
        pageItems={staticConfig.editVaultConfigurationBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
            initialValues={formData.configForm}
            onValuesChange={(changedValues, allValues) => {
              setFormData((prev) => ({
                ...prev,
                configForm: allValues,
              }));
            }}
          >
            <Divider style={{ marginTop: 5, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.vaultConfiguration}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.branch}
                  name={"operationId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.branch),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase(),
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.branch,
                      "select",
                    )}
                    options={branchConfigList}
                    allowClear
                    showSearch
                    disabled
                    onChange={(val) => setSelectedbranchConfigValue(val)}
                    className="of-bold-disable-input"
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.vaultGL} name={"vaultGl"}>
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase(),
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.vaultGL,
                      "select",
                    )}
                    showSearch
                    options={glAccountData}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.tillGL} name={"tillGl"}>
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase(),
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.vaultGL,
                      "select",
                    )}
                    showSearch
                    options={glAccountData}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                Currency Information
              </Title>
            </Divider>
            <CurrencyModal
              isModalOpen={isModalOpen}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsModalOpen={setIsModalOpen}
              setConfigureCurrencyTableSource={setConfigureCurrencyTableSource}
              configureCurrencyTableSource={configureCurrencyTableSource}
              CurrencyCount={currencyCount}
              setCurrencyCount={setCurrencyCount}
              currencyData={currencyData}
              selectedbranchConfigValueCurrencyCode={
                selectedbranchConfigValueCurrencyCode
              }
              setFormData={setFormData}
              formData={formData}
            />

            {configureCurrencyTableSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {configureCurrencyTableSource.length > 1
                      ? "Added Currencies"
                      : "Added Currency"}
                  </Title>
                </Divider>
                <Table
                  columns={columns}
                  dataSource={configureCurrencyTableSource}
                  bordered
                  pagination={{
                    position: "bottomCentre",
                    pageSize: "10",
                  }}
                />
              </>
            )}

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default EditVaultConfiguration;

const CurrencyModal = (props) => {
  const {
    isLoading,
    setIsLoading,
    setConfigureCurrencyTableSource,
    configureCurrencyTableSource,
    isModalOpen,
    setIsModalOpen,
    CurrencyCount,
    setCurrencyCount,
    selectedbranchConfigValueCurrencyCode,
    currencyData,
    formData,
    setFormData,
  } = props;

  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCurrencyFormSave = (formValues) => {
    // Get all current IDs from formData and local table source
    const allIds = [
      ...formData.currencyForm.map((item) => item.id),
      ...configureCurrencyTableSource.map((item) => item.id),
    ];

    // Function to find the next unused ID
    const getNextUniqueId = (existingIds) => {
      let id = 0;
      while (existingIds.includes(id)) {
        id++;
      }
      return id;
    };

    const nextId = getNextUniqueId(allIds);

    const newCurrencyInfo = {
      key: nextId,
      id: nextId,
      currencyCode: formValues.currencyCode,
      vaultMaxAmount: formValues.maximumVaultLimit,
    };

    let foundLimits = configureCurrencyTableSource.find(
      (item) => item.currencyCode === newCurrencyInfo?.currencyCode,
    );
    if (foundLimits) {
      BOM.AlertMsg(cnt.WARNING, "No Duplicate Limit Allowed!");
      return;
    }

    setConfigureCurrencyTableSource([
      ...configureCurrencyTableSource,
      newCurrencyInfo,
    ]);

    setFormData((prev) => ({
      ...prev,
      currencyForm: [...prev.currencyForm, newCurrencyInfo],
    }));

    form.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
      >
        <PlusCircleOutlined />
        &nbsp; {"Add"}
      </Button>

      <Modal
        title="Limit Information Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={form}
            layout="vertical"
            onFinish={handleCurrencyFormSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="currencyCode"
                label={labelConfig.vaultCurrency}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.vaultCurrency),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase(),
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.currency,
                    "select",
                  )}
                  options={selectedbranchConfigValueCurrencyCode}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="maximumVaultLimit"
                label={labelConfig.maximumVaultLimit}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.maximumVaultLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.maximumVaultLimit,
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
